import type { TaskStatus } from '../../interfaces/IScheduler.js';

/**
 * The task's PLAN status (2026-09-17 task-commit design). `committed` is not a
 * status — it is `task.committed`, rendered as its own chip beside these.
 */

/** i18n key suffix for each status (used inside `t('scheduler.status.${key}')`). */
export const STATUS_KEY: Record<TaskStatus, string> = {
  planned: 'planned',
  blocked: 'blocked',
  done: 'done',
};
